import styled from 'styled-components'

export const Container = styled.div`
  margin: 0 auto;
  min-width: 0;
`

export const ContentContainer = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.large} ${({ theme }) => theme.spacing.large};

  @media (max-width: 768px) {
    padding: ${({ theme }) => theme.spacing.medium};
  }
`

export const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 20px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 640px) {
    gap: 8px;
    margin-bottom: 16px;
  }
`

export const TabContainer = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 20px;
  padding: 3px;
  border-radius: 6px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 640px) {
    gap: 4px;
    margin-bottom: 16px;
  }
`

export const Tab = styled.button<{ $active: boolean }>`
  padding: 8px 16px;
  min-height: 36px;
  border: none;
  background: ${(props) => (props.$active ? props.theme.colors.background.primary : 'transparent')};
  color: ${(props) =>
    props.$active ? props.theme.colors.text.primary : props.theme.colors.text.secondary};
  font-size: 12px;
  font-weight: ${(props) => (props.$active ? '600' : '500')};
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${({ theme }) => theme.colors.background.primary};
  }
`

export const TabSubtitle = styled.div`
  position: relative;
  padding: ${({ theme }) => theme.spacing.small} ${({ theme }) => theme.spacing.default};
  margin: ${({ theme }) => theme.spacing.small} 0 ${({ theme }) => theme.spacing.medium} 0;
  background: ${({ theme }) => theme.colors.background.secondary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.shadows.sm};
  min-width: 0;
  overflow: hidden;

  @media (min-width: 768px) {
    padding: ${({ theme }) => theme.spacing.medium} ${({ theme }) => theme.spacing.large};
    margin: ${({ theme }) => theme.spacing.medium} 0 ${({ theme }) => theme.spacing.large} 0;
  }
`

export const TabSubtitleHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.small};
  margin-bottom: ${({ theme }) => theme.spacing.xsmall};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
  color: ${({ theme }) => theme.colors.text.primary};

  @media (min-width: 768px) {
    font-size: ${({ theme }) => theme.typography.fontSize.body};
  }

  /* Ensure icon doesn't shrink */
  svg {
    flex-shrink: 0;
  }
`

export const TabSubtitleBadge = styled.span<{ $color?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  background: ${({ $color }) => ($color || '#0294df') + '15'};
  color: ${({ $color }) => $color || '#0294df'};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const TabSubtitleDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.micro};
  line-height: 1.5;
  max-width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;

  @media (min-width: 768px) {
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    line-height: 1.6;
  }
`

export const ZonesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const EmptyState = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
`

export const ErrorState = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 12px;
`

export const LoadingState = styled.div`
  text-align: center;
  padding: 32px 16px;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 12px;
`
